import React from 'react';
import PropTypes from 'prop-types';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';

const TradeOffersRequestedDesktop = ({ tradeOffersRequested }) => {
  return (
    tradeOffersRequested.valueSeq().map((tradeOfferRequested) => (
      <div className='trade-post__row' key={ tradeOfferRequested.get('id') }>
        <div className='trade-post__cell trade-post__office'>
          {tradeOfferRequested.getIn(['requestedAppointment', 'office', 'name'])}
        </div>
        <div className='trade-post__cell trade-post__requester'>
          {tradeOfferRequested.getIn(['receiver', 'name'])}
        </div>
        <div className='trade-post__cell trade-post__offered-appt'>
          {convertDateToDayMonthYear(tradeOfferRequested.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
          {convertTime(tradeOfferRequested.getIn(['offeredAppointment', 'from']))}
        </div>
        <div className='trade-post__cell trade-post__requested-appt'>
          {convertDateToDayMonthYear(tradeOfferRequested.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
          {convertTime(tradeOfferRequested.getIn(['requestedAppointment', 'from']))}
        </div>
        <div className='trade-post__cell trade-post__status'>
          <span className={ 'trade-post__trade-status trade-post__trade-status--rejected' } >
            {tradeOfferRequested.get('status')}
          </span>
        </div>
      </div>
    ))
  );
};

TradeOffersRequestedDesktop.propTypes = {

};

export default TradeOffersRequestedDesktop;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/rejected/TradeOffersRequestedDesktop.jsx